// extracted by mini-css-extract-plugin
module.exports = {"StockDividendPage":"dividend_StockDividendPage__KoNLx","nextDividend":"dividend_nextDividend___vLrf"};